export default __webpack_public_path__ + "static/media/NM_LOAN_RATE_AND_FEES_DISCLOSURE.b237f75a.pdf";